<template>
    <b-card
        v-if="counters"
        class="card-transaction"
        border-variant="light"
        no-body
    >
        <b-card-header>
            <b-card-title>{{ label }}</b-card-title>
        </b-card-header>

        <b-card-body>
            <div
                v-for="transaction in counters"
                :key="transaction.key"
                class="transaction-item"
            >
                <b-media no-body>
                    <b-media-aside>
                        <b-avatar
                            rounded
                            size="42"
                            :variant="transaction.avatarVariant"
                        >
                            <feather-icon
                                size="18"
                                :icon="transaction.avatar"
                            />
                        </b-avatar>
                    </b-media-aside>
                    <b-media-body>
                        <h6 class="transaction-title">
                            {{ transaction.title }}
                        </h6>
                        <small>{{ transaction.description }}</small>
                    </b-media-body>
                </b-media>
                <div
                    class="font-weight-bolder"
                    :class="transaction.deduction ? 'text-danger':'text-success'"
                >
                    {{ transaction.payment }}
                </div>
            </div>
        </b-card-body>
    </b-card>
</template>

<script>
import {
    BCard, BCardHeader, BCardTitle, BCardBody, BMediaBody, BMedia, BMediaAside, BAvatar, BDropdown, BDropdownItem,
} from 'bootstrap-vue'

export default {
    components: {
        BCard,
        BCardHeader,
        BCardTitle,
        BCardBody,
        BMediaBody,
        BMedia,
        BMediaAside,
        BAvatar,
        BDropdown,
        BDropdownItem,
    },
    props: {
        counters: {
            type: Array,
            default: () => [],
        },
        label: {
            type: String,
            required: true,
        }
    },
}
</script>
